import * as React from 'react';
import * as _ from 'underscore';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';
import { IToast, ToasterService } from '../../../ts/services/ToasterService';
import { Toast } from './Toast';

export class Toaster extends React.Component<Toaster.Props, Toaster.State> {

  public static displayName = 'Toaster';

  state: Toaster.State = { toasts: [] };

  public static element = React.createFactory(Toaster);
  private angularContext: AngularContext;

  private listenerId: number;

  private toasterService: ToasterService;

  private boundListenerFn: (t: IToast[]) => void = this.toastsUpdated.bind(this);

  constructor(props: Toaster.Props) {
    super(props, {});
    this.angularContext = this.props.angularContext;
    this.toasterService = this.angularContext.getService('ToasterService');
  }

  public componentDidMount() {
    this.listenerId = this.toasterService.addListener({ toastsUpdated: this.boundListenerFn });
  }

  public componentWillUnmount() {
    this.toasterService.removeListener(this.listenerId);
  }

  private close(id: number) {
    this.toasterService.close(id);
  }

  public toastsUpdated(toastOptionsArray: IToast[]) {
    const newToasts: React.ReactElement<any>[] = [];
    _.each(toastOptionsArray, (toastOptions) => {

      const t = Toast.element({
        key: toastOptions.id,
        close: () => { this.close(toastOptions.id); },
        toastType: toastOptions.type,
        timeoutDelay: toastOptions.timeoutDelay,
        toastContent: toastOptions.content,
        lines: toastOptions.lines,
        testId: toastOptions.testId
      });

      newToasts.push(t);
    });

    this.setState({ toasts: newToasts });
  }

  public render() {
    return React.createElement('div', { style: {top: '4px'}, className: 'tb-toaster tb-enable-selection' }, this.state.toasts);
  }

}

export module Toaster {

  export interface Props extends ReactDirectiveProps {
    angularContext: AngularContext;
  }

  export interface State {
    toasts?: React.ReactElement<any>[];
  }

}
